import React from 'react';

const ReportsButton = ({ onClick }) => {
  return (
    <button
      className="fab reports-button"
      onClick={onClick}
      title="Relatórios"
      aria-label="Abrir relatórios"
    >
      📈
    </button>
  );
};

export default ReportsButton;